import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { store } from "@/state/store";
import { pushEvent } from "@/services/dataLayerLogin";
import SharedButton from "@SharedVueComponents/SharedButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppleLogin',
  setup(__props) {

function startAppleLogin() {
	window.location.href = `${store.oAuthSignIn}?kc_idp_hint=apple`;
	pushEvent("AppleButton");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SharedButton, {
    variant: "secondary",
    "append-icon": "social-apple",
    "icon-prefix": false,
    "aria-label": "Apple Anmeldung",
    onClick: startAppleLogin
  }))
}
}

})